module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8019.116f7111.png";